import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {Spinner} from 'react-bootstrap';
import React from 'react'

export default function BarChart(props) {

    Highcharts.setOptions({
        lang: {
            numericSymbols: ["k", "m", "G", "T", "P", "E"],
            thousandsSep: ','
        }
    });

    const options = {
        chart: {
            height: props.height, type: props.horizontal ? 'bar' : 'column', scrollablePlotArea: props.scrollbar ? {
                minHeight: props.minScrollHeight || 200, opacity: 10
            } : null
        },
        title: {
            text: props.title
        },
        xAxis: {
            categories: props.categories, crosshair: true, labels: {
                style: {
                    whiteSpace: 'nowrap'
                },
                formatter: function ()  {
                    const hebrew = /[\u0590-\u05FF]/;
                    const x = this.value;
                    if (x.length > 20) {
                        if (!hebrew.test(x)) {
                            return x.substring(0, 20) + '...';
                        } else {
                            return '...' + x.substring(0, 20);
                        }
                    }
                    return x;
                }
            }
        },
        yAxis: {
            min: 0, title: {
                text: ''
            }, crosshair: false,
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: `<tr><td style="color:{series.color};padding:0">{series.name}: </td><td style="padding:0"><b>{point.y} ${props.volumeUnit}</b></td></tr>`,
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2, borderWidth: 0,
            },
            bar: {
                pointWidth: props.chartPointWidth, groupPadding: 0,
            },
            series: {
                events: {
                    click: function (event) {
                        if (props.onClick) {
                            props.onClick(event);
                        }
                    }
                },
            }
        },
        credits: {
            enabled: false
        },
        series: props.data
    }

    return (<>
        {!props.data && <Spinner animation="border" variant="primary"/>}
        {props.data && <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />}
    </>)
}
